import { PropTypes } from 'prop-types';
import React, { memo } from 'react';

const EquipmentIcon = ({ size, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      data-testid="equipment-icon"
      className={`fill-current text-${color}`}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 6.00219V10.5472C16.965 11.0197 17.25 11.6647 17.25 12.3772C17.25 13.8247 16.0725 15.0022 14.625 15.0022C13.1775 15.0022 12 13.8247 12 12.3772C12 12.2816 12.0127 12.1859 12.0253 12.0903C12.0295 12.0584 12.0337 12.0266 12.0375 11.9947H8.1675C8.1225 12.2047 8.0625 12.4147 7.9875 12.6097L7.3125 12.3097L7.155 12.6547L7.8225 12.9547C7.4325 13.7272 6.795 14.3422 6 14.6872L5.7375 13.9897L5.385 14.1247L5.64 14.8072C5.28 14.9197 4.8975 15.0022 4.5 15.0022C4.02 15.0022 3.555 14.9047 3.1425 14.7397L3.4425 14.0647L3.0975 13.9072L2.7975 14.5747C2.025 14.1847 1.41 13.5472 1.065 12.7522L1.7625 12.4897L1.6275 12.1372L0.945 12.3922C0.8325 12.0322 0.75 11.6497 0.75 11.2522C0.75 10.7722 0.8475 10.3072 1.0125 9.89469L1.6875 10.1947L1.845 9.84969L1.1775 9.54969C1.5675 8.77719 2.205 8.16219 3 7.81719L3.2625 8.51469L3.615 8.37969L3.36 7.69719C3.72 7.58469 4.1025 7.50219 4.5 7.50219C4.98 7.50219 5.445 7.59969 5.8575 7.76469L5.5575 8.43969L5.9025 8.59719L6.2025 7.92969C6.3825 8.02719 6.555 8.13219 6.72 8.25219H8.25C9.075 8.25219 9.75 7.57719 9.75 6.75219V5.03469L8.955 4.23969L7.8975 5.29719L7.365 4.76469L10.0125 2.11719L10.545 2.64969L9.4875 3.70719L10.2825 4.50219H15C15.825 4.50219 16.5 5.17719 16.5 6.00219ZM2.25 11.2522C2.25 12.4972 3.255 13.5022 4.5 13.5022C5.745 13.5022 6.75 12.4972 6.75 11.2522C6.75 10.0072 5.745 9.00219 4.5 9.00219C3.255 9.00219 2.25 10.0072 2.25 11.2522ZM8.055 10.1122C8.0925 10.2397 8.1225 10.3672 8.1525 10.5022H12.795C13.2675 10.0372 13.9125 9.75219 14.625 9.75219C14.724 9.75219 14.823 9.76576 14.9185 9.77885C14.946 9.78261 14.9732 9.78634 15 9.78969V6.00219H11.25V6.75219C11.25 8.40969 9.9075 9.75219 8.25 9.75219H7.935L7.2375 10.0147L7.3725 10.3672L8.055 10.1122ZM13.5 12.3772C13.5 12.9997 14.0025 13.5022 14.625 13.5022C15.2475 13.5022 15.75 12.9997 15.75 12.3772C15.75 11.7547 15.2475 11.2522 14.625 11.2522C14.0025 11.2522 13.5 11.7547 13.5 12.3772ZM6.75 6.75195H3C2.5875 6.75195 2.25 6.41445 2.25 6.00195C2.25 5.58945 2.5875 5.25195 3 5.25195H5.25C6.075 5.25195 6.75 5.92695 6.75 6.75195Z"
      />
    </svg>
  );
};

EquipmentIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number
};

EquipmentIcon.defaultProps = {
  color: 'neutral-600',
  size: 18
};

export default memo(EquipmentIcon);
